import { parseU64Required } from "@bridgesplit/utils";
import { OracleProvider } from "@bridgesplit/abf-sdk";

import {
    ParsedMarketInformationApi,
    MarketInformationAssetDataApi,
    ParsedMarketInformationWithLtvInfoApi
} from "../api/market";
import { ParsedMarketInformation, MarketInformationAssetData, ParsedMarketInformationWithLtvInfo } from "../domain";

export function parseMarketInformationFromApi(api: ParsedMarketInformationApi): ParsedMarketInformation {
    return {
        id: api.id,
        address: api.address,
        authority: api.authority,
        delegate: api.delegate,
        principalMint: api.principalMint,

        max1hrBorrow: parseU64Required(api.max1hrBorrow).unwrap(),
        max24hrBorrow: parseU64Required(api.max24hrBorrow).unwrap(),
        maxOutstandingBorrow: parseU64Required(api.maxOutstandingBorrow).unwrap(),

        max1hrSupply: parseU64Required(api.max1hrSupply).unwrap(),
        max24hrSupply: parseU64Required(api.max24hrSupply).unwrap(),
        maxOutstandingSupply: parseU64Required(api.maxOutstandingSupply).unwrap(),

        max1hrWithdraw: parseU64Required(api.max1hrWithdraw).unwrap(),
        max24hrWithdraw: parseU64Required(api.max24hrWithdraw).unwrap(),
        maxOutstandingWithdraw: parseU64Required(api.maxOutstandingWithdraw).unwrap(),

        version: api.version,
        lastInteractedTime: parseU64Required(api.lastInteractedTime).unwrap(),
        lastInteractedTxn: api.lastInteractedTxn,
        verified: api.verified,
        writeVersion: parseU64Required(api.writeVersion).unwrap(),
        isDefault: api.isDefault,

        name: api.name,
        metadata: api.metadata
    };
}

export function parseMarketInformationAssetDataFromApi(api: MarketInformationAssetDataApi): MarketInformationAssetData {
    return {
        id: api.id,
        assetIdentifier: api.assetIdentifier,
        marketInformation: api.marketInformation,
        index: api.index,

        quoteMint: api.quoteMint,
        oracleAccount: api.oracleAccount,
        oracleType: api.oracleType,
        oracleProvider: api.oracleProvider as OracleProvider,
        maxUncertainty: api.maxUncertainty,
        maxAge: api.maxAge,

        decimals: api.decimals,
        ltv: api.ltv,
        liquidationThreshold: api.liquidationThreshold,

        maxCollateralAllocationPct: parseU64Required(api.maxCollateralAllocationPct).unwrap(),
        currentAllocationAmount: parseU64Required(api.currentAllocationAmount).unwrap(),

        lastInteractedTime: parseU64Required(api.lastInteractedTime).unwrap(),
        lastInteractedTxn: api.lastInteractedTxn,
        writeVersion: parseU64Required(api.writeVersion).unwrap()
    };
}

export function parseMarketInformationWithLtvInfoFromApi(
    api: ParsedMarketInformationWithLtvInfoApi
): ParsedMarketInformationWithLtvInfo {
    return {
        marketInformation: parseMarketInformationFromApi(api.marketInformation),
        // Empty for slim (`includeAssetInfo: false`) responses; full responses populate it.
        marketInformationAssetInfo: (api.marketInformationAssetInfo ?? []).map(parseMarketInformationAssetDataFromApi),
        underlyingAssets: api.underlyingAssets
    };
}
